import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
const START_SECONDS = 23 * 3600 + 58 * 60 + 24;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: hours,
    suffix: 'hrs'
  }, {
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-brand text-white" data-id="element-32" data-mp="ami4q1ki0o50">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-4 py-2 text-[11px] font-bold uppercase tracking-[0.14em] sm:text-xs" data-id="element-33" data-mp="6okbmnnlxhwc">
        <HourglassIcon className="h-3.5 w-3.5 text-lime" aria-hidden="true" data-id="element-34" data-mp="18cu1k2dubz8x" />
        <span data-id="element-35" data-mp="18ar10of2anpy">Launch offer ends in:</span>
        <span className="flex items-center gap-1 tabular-nums" aria-live="off" data-id="element-36" data-mp="ue44gmr0tzkk">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-1" data-id="element-37" data-mp="yfpf01g321rl" data-mpi={index}>
              <span className="font-display text-sm font-extrabold text-lime sm:text-base" data-id="element-38" data-mp="1m48lcbfko4h1">
                {pad(unit.value)}
              </span>
              <span className="text-[9px] tracking-normal text-white/80" data-id="element-39" data-mp="1r5pipwyul8sv">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="px-0.5 text-white/50" data-id="element-40" data-mp="1hch26lyqx10x">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}